export default __webpack_public_path__ + "static/media/onboarding1.156e7a27.svg";